import { Dashboard } from "@/modules/Dashboard";
import { useSuppliersStore } from "@/shared/stores/suppliersStore";
import { useEffect, useMemo } from "react";
import { ServiceCatalog } from "@/modules/ServiceCatalog/ServiceCatalog";
import { useRouter } from "@tanstack/react-router";
import { useUiStore } from "@/shared/stores/uiStore";
import { useLaunchParams } from "@telegram-apps/sdk-react";

const START_ACTION_HANDLED_KEY = "startActionHandled";

export function Home() {
  const router = useRouter();
  const { openModal } = useUiStore();
  const launchParams = useLaunchParams();

  const { suppliers, selectedSupplierId, fetchSuppliers, selectSupplier } =
    useSuppliersStore();

  useEffect(() => {
    fetchSuppliers();
  }, [fetchSuppliers]);

  useEffect(() => {
    const isActionHandled =
      sessionStorage.getItem(START_ACTION_HANDLED_KEY) === "true";
    if (isActionHandled) {
      return;
    }

    const encoded = launchParams.tgWebAppData?.start_param;

    if (!encoded) return;

    try {
      const decoded = atob(encoded);
      const params = JSON.parse(decoded) as {
        action:
          | "add_token"
          | "pay"
          | "add_service"
          | "get_table"
          | "top_up_balance";
        service_type?: "autojam" | "autotables";
        supplier_id?: string;
        table_id?: string;
      };

      if (params.action === "add_token") {
        openModal("TOKEN", {});
        sessionStorage.setItem(START_ACTION_HANDLED_KEY, "true");
      }
      if (params.action === "pay") {
        const { service_type, supplier_id, table_id } = params;
        if (!service_type || !supplier_id || !table_id) return;
        sessionStorage.setItem(START_ACTION_HANDLED_KEY, "true");
        router.navigate({
          to: "/service/$id",
          params: { id: service_type },
          search: { pId: supplier_id, stage: "payment", tableId: table_id },
        });
      } else if (params.action === "get_table") {
        const { service_type, supplier_id, table_id } = params;
        if (!service_type || !supplier_id || !table_id) return;
        sessionStorage.setItem(START_ACTION_HANDLED_KEY, "true");
        router.navigate({
          to: "/service/$id",
          params: { id: service_type },
          search: { pId: supplier_id, stage: "status", tableId: table_id },
        });
      } else if (params.action === "add_service") {
        const { service_type } = params;
        if (!service_type) return;
        sessionStorage.setItem(START_ACTION_HANDLED_KEY, "true");
        router.navigate({
          to: "/service/$id",
          params: { id: service_type },
        });
      } else if (params.action === "top_up_balance") {
        const { supplier_id } = params;
        if (supplier_id) {
          selectSupplier(supplier_id);
          openModal("TOP_UP_BALANCE", {});
          sessionStorage.setItem(START_ACTION_HANDLED_KEY, "true");
        }
      }
    } catch (e) {
      console.error("Failed to decode or process start_param:", e);
    }
  }, [
    launchParams.tgWebAppData?.start_param,
    openModal,
    router,
    selectSupplier,
  ]);

  const currentSupplier = useMemo(
    () => suppliers.find((p) => p.id === selectedSupplierId),
    [suppliers, selectedSupplierId],
  );

  return (
    <>
      {selectedSupplierId && suppliers.length > 0 && (
        <>
          <Dashboard />
          <ServiceCatalog
            personId={selectedSupplierId}
            supplier={currentSupplier}
          />
        </>
      )}
    </>
  );
}
